<div *ngIf="data?.length"
     class="toggle-wrapper w-full">
  <div class="flex h-full justify-start items-center lg:overflow-y-auto overflow-y-scroll week-list-wrapper">
    <div (click)="select(week)"
         *ngFor="let week of data;let index=index"
         [class.disabled]="isFuture(week)"
         [class.selected]="week.isSelected"
         class="week-wrapper flex flex-col
        items-center
        justify-center
        min-w-[50%]
        max-w-[50%]
        sm:min-w-[14.28%]
        sm:max-w-[14.28%]
        h-full">
      <div class="w-full flex justify-center items-center">
        <span [ngClass]="week?.completed ? 'day-label-completed':'day-label'">
            {{ week?.date | date : 'EEE' }}
        </span>
        <span
          *ngIf="week['isNormalJournalingRLExists'] ||
                  week['isNormalJournalingPAExists'] ||
                  week['isNormalJournalingSTExists']"
          class="check-icon-wrapper"
        >
            <app-icon class="check-icon" svgIcon="check-circle" />
        </span>
      </div>
      <div>
        <span *ngIf="week?.sessionNumber" class="session">{{ 'S' + week?.sessionNumber }}</span>
        <span class="date-label">{{ week?.date | date:'MMM dd' }}</span>
      </div>
    </div>
  </div>
</div>
